import moment from 'moment'
export default {
  methods: {
    explicitDateFormat(value) {
      if(value){
        return moment(String(value)).format('DD/MM/YYYY [a las] hh:mm a')
      }
    },
    sessionFormat(value) {
      if(value){
        return moment(String(value)).format('DD/MM/YYYY h:mm a')
      }
    },
    regularDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD/MM/YYYY')
      }
    },
    midDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD [de] MMMM [de] YYYY')
      }
    },
    humanDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('D MMM YYYY')
      }
    },
    dateTimeFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD/MM/YYYY HH:mm')
      }
    },
    dateTime12Format(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD/MM/YYYY h:mm a')
      }
    },
    compactDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD [de] MMM [´]YY')
      }
    },
    logDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD [de] MMMM [de] YYYY HH:mm')
      }
    },
    timeAgoFormat(value) {
      if(value){
        return moment(String(value)).locale("es").fromNow();
      }
    },
    calculateAgeFromDate(value){
      if(value){
        return moment().diff(value, 'years');
      }
    },
    minDateForValidAge(years){
      return moment().subtract(years, 'years').format();
    },
    calculateDaysDiff(value){
      if(value){
        let m = moment(String(value));
        let n = moment();
        return n.diff(m, 'days');
      }
    },
    validatedDate(value){
      if(value){
        let m = moment(String(value));
        if(m.isValid()){
          return m.locale("es").format('DD/MM/YYYY');
        }
        else {
          return "--";
        }
      }
    },
    getDateFromInputs(yy,mm,dd){
      let yint =  parseInt(yy);
      let mint = parseInt(mm);
      mint -= 1;
      if(yint <= 20){
        // suponer que el año es entre 2000 y 2010
        yint += 2000;
      }
      else {
        // suponer que el año es menor a 2000
        yint += 1900;
      }

      let m = moment({ year: yint, month: mint, day: dd});
      if(m.isValid()){
        return m.format('YYYY-MM-DD');
      }
      else {
        return false;
      }
    },
    getDayWeek(day){
      var number_day;
      switch(day) {
         case 'DOMINGO':
            number_day = 0;
            break;
         case 'LUNES':
            number_day = 1;
            break;
         case 'MARTES':
            number_day = 2;
            break;
         case 'MIERCOLES':
            number_day = 3;
            break;
         case 'JUEVES':
            number_day = 4;
            break;
         case 'VIERNES':
            number_day = 5;
            break; 
         case 'SABADO':
            number_day = 6;
            break;                                                           
         default:
            number_day = 0;
      } 
      return number_day;       
   },
    // Función para calcular los días transcurridos entre dos fechas
    diferenciaFechas(f1,f2){
      var aFecha1 = f1.split('/');
      var aFecha2 = f2.split('/');
      var fFecha1 = Date.UTC(aFecha1[2],aFecha1[1]-1,aFecha1[0]);
      var fFecha2 = Date.UTC(aFecha2[2],aFecha2[1]-1,aFecha2[0]);
      var dif = fFecha2 - fFecha1;
      var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
      return dias;
    }        
  }
}